import React, { Component } from 'react';
import BaseLayout from './../../templates/base';
import ActivityEditForm from '../../elements/activities/form';
import Loading from "../../elements/loading";
import ActivityAdd from './../../elements/activities/widget/activity_add';

class ActivityEdit extends Component {
	render() {
		const { activities} = this.props;
		return (
			activities.isFetching  ? <Loading/>: <ActivityEditForm {...this.props}/>
		)
	}

	componentWillMount() {
		this.props.fetchActivityComplete(this.props.match.params.id);
	}
}

export default BaseLayout(ActivityEdit, {
	title: `Editar Actividad`,
	subnav: {
		icon: 'fa-calendar-check-o',
		name: 'Proigualdad',
		actions: [
			{
				type: 'element',
				url: null,
				name: 'Agregar',
				element: <ActivityAdd />
			}
		]
	}
});



// WEBPACK FOOTER //
// ./src/layouts/activities/edit.jsx